export default "__VITE_ASSET__DPnjE5CB__"